/* eslint-disable @typescript-eslint/naming-convention */
import { getAccountBalance } from '@controllers/AlgorandController/Public/handleInteractApplication'
import AlgorandNetwork from '@providers/AlgorandNetwork'
import { THandleConnectWalletController } from '@providers/models'
import { __MICRO_ALGO_RATIO__ } from '@types'

export const handleConnectWalletAlgo = async (provider: AlgorandNetwork): Promise<THandleConnectWalletController> => {
    const algodclient = provider.getDefaultProvider()
    await provider.disconnect()
    await provider.connect()

    const accounts = await provider.getCurrentAccount()
    if (accounts.length > 0) {
        const accountBalance = await getAccountBalance(algodclient, accounts[0])
        let balance = '0'

        if (balance) {
            const fixedBalance = (accountBalance.amount / __MICRO_ALGO_RATIO__).toString()
            balance = fixedBalance
        }

        return {
            success: true,
            data: {
                balance,
                accounts,
            },
            message: 'Connected to wallet',
        }
    } else {
        if (provider.getCurrentWallet()) {
            return {
                success: false,
                error: `Create an account for ${provider.getCurrentWallet()}`,
            }
        }
        return {
            success: false,
            error: 'Connecting wallet failed',
        }
    }
}
